<div class="bg-white px-3 sm:px-4 md:px-8 lg:px-16 pt-6 pb-3">
    <!-- Breadcrumb -->
    <div class="flex items-center gap-2 text-body text-base mb-6">
        <a routerLink="/" class="hover:text-primary">{{ 'common.home' | translate }}</a>
        <svg class="w-4 h-4 rtl:rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
        </svg>
        <span>{{ page.title }}</span>
    </div>
    <h1 class="text-heading text-2xl font-semibold">{{ page.title }}</h1>
</div>

<div class="bg-white px-3 sm:px-4 md:px-8 lg:px-16 pb-16 pt-3">
    <div class="max-w-[900px] flex flex-col gap-6 text-body">
        <section *ngFor="let s of page.sections" class="flex flex-col gap-2">
            <h2 *ngIf="s.heading" class="text-heading text-lg font-semibold">{{ s.heading }}</h2>
            <p *ngFor="let p of s.paras" class="text-base leading-7">{{ p }}</p>
            <ul *ngIf="s.bullets?.length" class="list-disc ps-6 flex flex-col gap-1">
                <li *ngFor="let b of s.bullets" class="text-base leading-7">{{ b }}</li>
            </ul>
            <p *ngFor="let t of s.trailing" class="text-base leading-7">{{ t }}</p>
        </section>
    </div>
</div>
